import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const useScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Immediate scroll to top for instant feedback
    window.scrollTo(0, 0);
    
    // Additional scroll to top after a short delay to ensure it works
    // even if the page content loads after the initial render
    const scrollToTop = () => {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
    };

    // Use requestAnimationFrame for better timing
    const timer1 = requestAnimationFrame(() => {
      scrollToTop();
    });
    
    // Additional fallback with setTimeout
    const timer2 = setTimeout(scrollToTop, 50);
    
    // Final fallback for slow-loading pages
    const timer3 = setTimeout(scrollToTop, 200);
    
    return () => {
      cancelAnimationFrame(timer1);
      clearTimeout(timer2);
      clearTimeout(timer3);
    };
  }, [pathname]);
};

// Global scroll to top utility function
export const scrollToTop = () => {
  // Immediate scroll
  window.scrollTo(0, 0);
  
  // Multiple fallback scrolls
  const scrollToTopFn = () => window.scrollTo(0, 0);
  
  // Use requestAnimationFrame for better timing
  requestAnimationFrame(scrollToTopFn);
  
  // Multiple setTimeout fallbacks
  setTimeout(scrollToTopFn, 10);
  setTimeout(scrollToTopFn, 50);
  setTimeout(scrollToTopFn, 100);
  setTimeout(scrollToTopFn, 200);
  setTimeout(scrollToTopFn, 500);
  
  // Smooth scroll after a brief delay
  setTimeout(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }, 10);
}; 